import Instance from "../../../../Axios";

// New Actions for the app

const GetEstadosPropostas = (parceirosId, dataInicio, dataFim) => async (dispatch) => {
  await Instance()
    .get(`/energias/dashboard/estadosPropostas`, {
      params: { parceirosId, dataInicio, dataFim },
    })
    .then(({ data }) => {
      //   console.log(data);
      dispatch({
        type: "GET_ESTADOS_PROPOSTAS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetEstadosPropostas;